import React from "react";

import "./testimonials.scss";

const TESTIMONIALS = [
  {
    quote:
      "Ran a Decatur zip code on day one and it surfaced a duplex I'd completely missed on the MLS. Under contract within a week.",
    author: "Rachel T.",
    role: "3 flips completed",
    location: "Atlanta, GA",
  },
  {
    quote:
      "I was paying for PropStream and BatchLeads and still spending weekends driving for dollars. This pulls from better sources than both of them combined.",
    author: "James W.",
    role: "Full-time investor",
    location: "Dallas, TX",
  },
  {
    quote:
      "The contractor scores are the real differentiator. I got burned by a contractor who ghosted mid-rehab last year — this would have flagged his completion rate before I hired him.",
    author: "Marcus L.",
    role: "2 flips completed",
    location: "Phoenix, AZ",
  },
  {
    quote:
      "Deal Score caught a lien on a property I was about to offer on. My title search would have found it eventually, but not before I wasted two weeks.",
    author: "Dani K.",
    role: "Wholesaler, 40+ deals",
    location: "Charlotte, NC",
  },
  {
    quote:
      "The rehab estimate was within $3K of my contractor's actual bid. That's better than most appraisers I've worked with.",
    author: "Carlos M.",
    role: "Buy & hold, 12 doors",
    location: "Houston, TX",
  },
];

// Double the list so the CSS marquee loops seamlessly.
const TRACK = [...TESTIMONIALS, ...TESTIMONIALS];

const Testimonials = () => (
  <section className="testimonials">
    <h2 className="testimonials-heading">What beta testers are saying</h2>
    <div className="testimonials-marquee">
      <div className="testimonials-track">
        {TRACK.map((t, i) => (
          <div key={i} className="testimonial-card">
            <p className="testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
            <div className="testimonial-author">
              <span className="testimonial-name">{t.author}</span>
              <span className="testimonial-role">{t.role}</span>
              <span className="testimonial-location">{t.location}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
